@import '../../../../constants/spacing.module.less';

.supplier-filter-container {
  padding: @space-12;
  min-width: 300px;
}
